import { render, staticRenderFns } from "./UserCreateAddresses.vue?vue&type=template&id=ae65a1ec&scoped=true&"
import script from "./UserCreateAddresses.vue?vue&type=script&lang=js&"
export * from "./UserCreateAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae65a1ec",
  null
  
)

export default component.exports